import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Movement of Equity";
const description = `The Movement of Equity report tracks the changes in a company's equity over a specific period. It begins with the opening balance, adds any profits or new investments, subtracts any losses or distributions to owners, and concludes with the closing balance. This report explains exactly how the owners' stake in the business changed from the beginning to the end of the period.`;

const images = [
    '/images/reports/business-overview/movement-of-equity/movement-of-equity.png', // 0
];


const MovementOfEquity: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MovementOfEquity;
